// import dashboard from './dashboard';
import customermgmt from './customermgmt';
import settingsmgmt from './settingsmgmt';
// import other from './other';

const menuItems = {
  items: [customermgmt, settingsmgmt]
};

export default menuItems;
